import styled, { css } from 'styled-components';

import { ModalTriggerProps } from '.';

export const ModalTriggerContainer = styled.button<ModalTriggerContainerProps>`
  position: relative;
  width: 24px;
  height: 24px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 0 8px;
  background-color: transparent;
  border-radius: 50%;
  appearance: none;
  border: 0;
  cursor: pointer;
  top: -10px;

  svg {
    height: 24px;
    width: 24px;
  }

  @media (hover: hover) {
    transition: opacity 0.15s ease;

    &:hover {
      opacity: 0.6;
    }
  }

  ${({ size }) =>
    size === 'small' &&
    css`
      width: 15px;
      height: 15px;
      top: -6px;

      svg {
        height: 15px;
        width: 15px;
      }
    `}
`;

export const TextButton = styled.button`
  border: none;
  background: transparent;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.gray['1200']};
  outline: none;
  text-decoration: underline;
  margin: 0;
  padding: 0;
  transition: color 0.2s ease;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.gray['800']};
  }
`;

type ModalTriggerContainerProps = Pick<ModalTriggerProps, 'variant' | 'size'>;
